// extracted by mini-css-extract-plugin
module.exports = {"DiceButton":"ColorGenerator_DiceButton__A1mDK"};